import { useEffect, useState } from "react";
import StaffStats from "./StaffStats";
import StaffsTable from "./StaffsTable";
import StaffModal from "./StaffModal";
// import { getStaffList } from "../../services/staffService";
import { useUser } from "../../context/AuthContext";
 
const ManageStaffs = () => {
  const [open, setOpen] = useState(false);
  const [editData, setEditData] = useState(null);
  const [staffs, setStaffs] = useState([]);
  const [loading, setLoading] = useState(false);

  const { user } = useUser();
  const groupId = user?.data?.Groups?.[0]?.GroupId;

  const loadStaffs = async () => {
    if (!groupId) return;

    // try {
    //   setLoading(true);
    //   const res = await getStaffList({ GroupId: groupId });
    //   setStaffs(res || []);
    // } catch (e) {
    //   console.error("Staff API Error", e);
    //   setStaffs([]);
    // } finally {
    //   setLoading(false);
    // }
  };

  useEffect(() => {
    loadStaffs();
  }, [groupId]);

  return (
    <div className="manage-students-page">
      {/* HEADER */}
      <div className="page-header">
        <h2>Manage Staff</h2>
        <button className="primary-btn" onClick={() => setOpen(true)}>
          + Add Staff
        </button>
      </div>

      <StaffStats staffs={staffs} />

      <StaffsTable
        data={staffs}
        loading={loading}
        onEdit={(row) => {
          setEditData(row);
          setOpen(true);
        }}
      />

      {open && (
        <StaffModal
          data={editData}
          onClose={() => {
            setEditData(null);
            setOpen(false);
            loadStaffs();
          }}
        />
      )}
    </div>
  );
};

export default ManageStaffs;
